var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6423 12L23.6599 22.0176C24.1134 22.4711 24.1134 23.2064 23.6599 23.6599C23.2064 24.1134 22.4711 24.1134 22.0176 23.6599L12 13.6423L1.98245 23.6599C1.52893 24.1134 0.793646 24.1134 0.340134 23.6599C-0.113378 23.2064 -0.113378 22.4711 0.340134 22.0176L10.3577 12L0.340134 1.98245C-0.113378 1.52893 -0.113378 0.793646 0.340134 0.340134C0.793646 -0.113378 1.52893 -0.113378 1.98245 0.340134L12 10.3577L22.0176 0.340134C22.4711 -0.113378 23.2064 -0.113378 23.6599 0.340134C24.1134 0.793646 24.1134 1.52893 23.6599 1.98245L13.6423 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupClose);
export default __webpack_public_path__ + "static/media/popup-close.a6c57d1c40e3f2f41b0198e1e6700bd2.svg";
export { ForwardRef as ReactComponent };